import block from "./block";
import component from "./component";

export default (editor, opts = {}) => {
  editor.DomComponents.addType("socialIcons", component(opts));
  editor.BlockManager.add("socialIcons", block(opts));
};